export default "__VITE_ASSET__j_uYWknn__"